/* eslint-disable @nx/enforce-module-boundaries */
import { Stack } from '@mybridge/ui';
import { forwardRef } from 'react';
import { MyJobPreferences } from '../job-preferences';
export const MyJobsListingLayout = forwardRef(({ children, ...props }, ref) => {
 
  return (
    <>
      <Stack>
        <MyJobPreferences />
        {children}
      </Stack>
    </>
  );
});
